import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTeacher: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTeacher"><Path d="M12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.433 10.067 9 12 9C13.933 9 15.5 7.433 15.5 5.5C15.5 3.567 13.933 2 12 2Z" fill="currentColor"/><Path d="M4.5 8.5H3V11H2V12.5H3V21H21V12.5H22V11H15.4641C14.5985 10.0777 13.3663 9.5 12 9.5C10.6337 9.5 9.40154 10.0777 8.53591 11H7V8.5H5.5V11H4.5V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTeacher;
